/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const ServicesIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <circle
        cx={8}
        cy={8}
        r={2}
        fill="none"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-cap="butt"
      />
      <polyline
        points="8 19 8 24 5.268 26.732"
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <polyline
        points="24 19 24 24 26.734 26.734"
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <circle
        cx={3.5}
        cy={28.5}
        r={2.5}
        fill="none"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-cap="butt"
        data-color="color-2"
      />
      <circle
        cx={28.5}
        cy={28.5}
        r={2.5}
        fill="none"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-cap="butt"
        data-color="color-2"
      />
      <circle
        cx={16}
        cy={28.5}
        r={2.5}
        fill="none"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-cap="butt"
        data-color="color-2"
      />
      <line
        x1={16}
        y1={26}
        x2={16}
        y2={16}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <path
        d="M14.317,5a7,7,0,1,0,0,6H21l2,2,2-2h4l1-6Z"
        fill="none"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-cap="butt"
      />
    </svg>
  );
};
